// check create search complete
import { Action } from '@ngrx/store';
import { CarSearchPayload } from '@shared/models/car-search-payload.model';
import { CarSearchResponse, CarSearchResult } from '@shared/models/car-search-response.model';
import { TravelCarHireFilterForm } from '@shared/shared/interfaces/travel-car-hire.interfaces';

// create search
export const CREATE_CAR_SEARCH = '[Travel Car Search] Create car search';

export const CLEAR_CAR_SEARCH = '[Travel Car Search] Clear car search';

export const CHECK_CAR_SEARCH_CANCEL = '[Travel Car Search] Cancel search';

export const GET_CAR_SEARCH_RESULTS = '[Travel Car Search] Get car search results';
export const GET_CAR_SEARCH_RESULTS_SUCCESS = '[Travel Car Search] Get car search results success';
export const GET_CAR_SEARCH_RESULTS_FAILURE = '[Travel Car Search] Get car search results failure';

export const FILTER_CAR_SEARCH_RESULTS = '[Travel Car Search] Filter car search results';

export const SELECT_CAR = '[Travel Car Search] Select car';

export const RESTORE_CAR_SEARCH = '[Travel Car Search] Restore car search';
export const RESTORE_CAR_SEARCH_SUCCESS = '[Travel Car Search] Restore car search success';

export class ClearCarSearch implements Action {
  readonly type = CLEAR_CAR_SEARCH;
}

export class CreateCarSearch implements Action {
  readonly type = CREATE_CAR_SEARCH;
  constructor(public payload: CarSearchPayload) {}
}

export class CancelCarSearch implements Action {
  readonly type = CHECK_CAR_SEARCH_CANCEL;
}

export class GetCarSearchResults implements Action {
  readonly type = GET_CAR_SEARCH_RESULTS;
  constructor(public payload: CarSearchPayload) {}
}

export class GetCarSearchResultsSuccess implements Action {
  readonly type = GET_CAR_SEARCH_RESULTS_SUCCESS;
  constructor(public payload: CarSearchResponse, public carHireInstalmentsFeatureSwitch?: boolean) {}
}

export class GetCarSearchResultsFailure implements Action {
  readonly type = GET_CAR_SEARCH_RESULTS_FAILURE;
  constructor(public payload: any) {}
}

export class FilterCarSearchResults implements Action {
  readonly type = FILTER_CAR_SEARCH_RESULTS;
  constructor(public payload?: TravelCarHireFilterForm) {}
}

export class SelectCar implements Action {
  readonly type = SELECT_CAR;
  constructor(public payload: { token: string; isBooking?: boolean }) {}
}

export class RestoreCarSearch implements Action {
  readonly type = RESTORE_CAR_SEARCH;
}

export class RestoreCarSearchSuccess implements Action {
  readonly type = RESTORE_CAR_SEARCH_SUCCESS;
  constructor(
    public payload: { carSearch: CarSearchPayload; selectedCar: CarSearchResult; carSearchReferenceId: string }
  ) {}
}

export type CarHireSearchActions =
  | ClearCarSearch
  | CreateCarSearch
  | GetCarSearchResults
  | GetCarSearchResultsSuccess
  | GetCarSearchResultsFailure
  | SelectCar
  | CancelCarSearch
  | FilterCarSearchResults
  | RestoreCarSearch
  | RestoreCarSearchSuccess;
